/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ResendWebhookRequestBuilderRequestsMetadata, type ResendWebhookRequestBuilder } from './resendWebhook/index.js';
// @ts-ignore
import { SentRequestBuilderNavigationMetadata, SentRequestBuilderRequestsMetadata, type SentRequestBuilder } from './sent/index.js';
// @ts-ignore
import { StatsRequestBuilderRequestsMetadata, type StatsRequestBuilder } from './stats/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/emails
 */
export interface EmailsRequestBuilder extends BaseRequestBuilder<EmailsRequestBuilder> {
    /**
     * The resendWebhook property
     */
    get resendWebhook(): ResendWebhookRequestBuilder;
    /**
     * The sent property
     */
    get sent(): SentRequestBuilder;
    /**
     * The stats property
     */
    get stats(): StatsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const EmailsRequestBuilderUriTemplate = "{+baseurl}/api/emails";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const EmailsRequestBuilderNavigationMetadata: Record<Exclude<keyof EmailsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    resendWebhook: {
        requestsMetadata: ResendWebhookRequestBuilderRequestsMetadata,
    },
    sent: {
        requestsMetadata: SentRequestBuilderRequestsMetadata,
        navigationMetadata: SentRequestBuilderNavigationMetadata,
    },
    stats: {
        requestsMetadata: StatsRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
